// extracted by mini-css-extract-plugin
var _1 = "aN3BgQEz3Q8CdrCxUy2_";
export { _1 as "searchMatch" }
